// extracted by mini-css-extract-plugin
export var cell = "FallbackIllustration-module--cell--f9e9c";
export var container = "FallbackIllustration-module--container--7fe78";
export var fixed = "FallbackIllustration-module--fixed--38f90";
export var scroll = "FallbackIllustration-module--scroll--ec621";